import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import ErrorFallback from './components/main/layouts/errors/ErrorFallback';

import CookieConsent from './services/cookie/CookieConsent';

import SplashScreen from './utils/SplashScreen/SplashScreen';
import './index.css'; 

import routes from './routes/index';

import HandleResponsive from './components/main/layouts/errors/HandleResponsive';

import reportWebVitals from './reportWebVitals';

import { ErrorBoundary } from 'react-error-boundary';

import ButtonHelpWrapper from './components/ButtonHelp/ButtonHelpWrapper';
import AgreementModal from './utils/agreements/AgreementModal';

// Fungsi untuk menampilkan pesan kesalahan

const SplashScreenWrapper = ({ children }) => {
  const [showSplash, setShowSplash] = useState(false);
  const location = useLocation();

  useEffect(() => { 
    setShowSplash(true);
    
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (showSplash) {
    return <SplashScreen onComplete={() => setShowSplash(false)} />;
  }

  return (
    <>
      {children}
    </>
  );
};

const App = () => {
  const [isAgreementAccepted, setIsAgreementAccepted] = useState(false);
  const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false);

  useEffect(() => {
    // Periksa apakah sudah pernah menyetujui sebelumnya
    const termsAccepted = localStorage.getItem('papakilo_terms_accepted');
    
    // Set state dan tandai load awal selesai
    setIsAgreementAccepted(!!termsAccepted);
    setIsInitialLoadComplete(true);
  }, []);

  // Tunggu proses load awal selesai
  if (!isInitialLoadComplete) {
    return null;
  }

  // Jika belum diterima, tampilkan modal
  if (!isAgreementAccepted) {
    return <AgreementModal onAccept={() => setIsAgreementAccepted(true)} />;
  }

  // Render aplikasi setelah syarat diterima
  return (
    <BrowserRouter>
      <SplashScreenWrapper>
        <CookieConsent />
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </SplashScreenWrapper>
      <ButtonHelpWrapper />
      <HandleResponsive />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();  